import React from 'react';
import {defineMessages} from 'react-intl';
import {LayoutDetailsBlock} from '@igp/shared/components/layout';

import {PlayerReferral} from './PlayerReferral';
import {PlayerReferralRevenueShare} from './PlayerReferralRevenueShare';

const localized = defineMessages({
    title: {
        id: 'UserReferralInfo_title',
        defaultMessage: 'Referrer Info',
    },
});

type PlayerReferralSummaryProps = {uid: string};

export function PlayerReferralSummary({uid}: PlayerReferralSummaryProps) {
    return (
        <LayoutDetailsBlock
            title={localized.title}
            content={
                <>
                    <PlayerReferral uid={uid} />
                    <PlayerReferralRevenueShare uid={uid} />
                </>
            }
        />
    );
}
